import React, { useEffect } from "react";
import { Modal, Spin, Alert, Typography } from "antd";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { centerItalyPosition } from "../MappaClienti/constants";
import { getMarkerIcon } from "../MappaClienti/markerIcons";

const { Text } = Typography;

const BoundsUpdater = ({ coordinates }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) {
      return;
    }

    map.invalidateSize();

    if (coordinates && coordinates.length > 0) {
      const positions = coordinates
        .filter((coord) =>
          typeof coord.latitude === "number" &&
          !Number.isNaN(coord.latitude) &&
          typeof coord.longitude === "number" &&
          !Number.isNaN(coord.longitude)
        )
        .map((coord) => [coord.latitude, coord.longitude]);

      if (positions.length === 0) {
        map.setView(centerItalyPosition, 6);
        return;
      }

      const bounds = L.latLngBounds(positions);
      if (bounds.isValid()) {
        map.fitBounds(bounds, { padding: [40, 40] });
      }
    } else {
      map.setView(centerItalyPosition, 6);
    }
  }, [map, coordinates]);

  return null;
};

const OrgsMapModal = ({ visible, loading, onClose, coordinates = [], error }) => {
  const count = coordinates.length;

  return (
    <Modal
      title="Visualizza su Mappa"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1000}
      destroyOnClose
    >
      {loading ? (
        <div
          style={{
            height: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin tip="Caricamento mappa..." />
        </div>
      ) : error ? (
        <Alert type="error" message={error} />
      ) : count === 0 ? (
        <Alert
          type="info"
          message="Nessuna organizzazione con coordinate disponibili per le impostazioni correnti."
        />
      ) : (
        <>
          <Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
            Mostrando {count} organizzazione{count !== 1 ? "i" : ""} sulla mappa.
          </Text>
          <div
            style={{
              borderRadius: 8,
              overflow: "hidden",
              border: "1px solid #f0f0f0",
            }}
          >
            <MapContainer
              center={centerItalyPosition}
              zoom={6}
              scrollWheelZoom
              style={{ height: "60vh", width: "100%" }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="© OpenStreetMap contributors"
              />
              <BoundsUpdater coordinates={coordinates} />
              {coordinates.map((coord) => {
                const org = coord.org_pointer;
                const position = [coord.latitude, coord.longitude];

                return (
                  <Marker
                    key={coord.objectId}
                    position={position}
                    icon={getMarkerIcon(org)}
                  >
                    <Popup>
                      <div>
                        {org?.nome && (
                          <strong>
                            {org.objectId ? (
                              <Link to={`/orgs/${org.objectId}`}>{org.nome}</Link>
                            ) : (
                              org.nome
                            )}
                          </strong>
                        )}
                        {org?.stato && org?.tipo_istanza && (
                          <div style={{ marginTop: 8 }}>
                            <span
                              style={{
                                color: org.stato === "attiva" ? "green" : "red",
                                fontWeight: 500,
                              }}
                            >
                              {org.stato === "attiva" ? "Attiva" : "Disattiva"}
                            </span>
                            {` — ${org.tipo_istanza}`}
                          </div>
                        )}
                        {org?.indirizzo && (
                          <div style={{ marginTop: 8 }}>
                            <strong>Indirizzo:</strong>
                            <br />
                            <a
                              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                `${org.indirizzo}, ${org.cap || ""} ${org.citta || ""}, ${org.nazione || "Italia"}`
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {org.indirizzo}
                              <br />
                              {[org.cap, org.citta].filter(Boolean).join(" ")}
                              <br />
                              {org.nazione || "Italia"}
                            </a>
                          </div>
                        )}
                        <div style={{ marginTop: 8 }}>
                          <a
                            href={`https://www.google.com/maps/search/?api=1&query=${coord.latitude},${coord.longitude}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Apri coordinate in Google Maps
                          </a>
                        </div>
                        {org?.nome && (
                          <div style={{ marginTop: 4 }}>
                            <a
                              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                org.nome
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Apri nome in Google Maps
                            </a>
                          </div>
                        )}
                      </div>
                    </Popup>
                  </Marker>
                );
              })}
            </MapContainer>
          </div>
        </>
      )}
    </Modal>
  );
};

export default OrgsMapModal;
